import { Injectable } from '@angular/core';
import { baseUri } from '../constants/uri.constants';
import { BaseServiceService } from '@app/services/base/services/base-service.service';
import { WaterNewContractServiceDto } from '@app/services/water-new-contract/types/water-new-contract-service-dto';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { StringUtils } from '@core/utils';

@Injectable({
    providedIn: 'root',
})
export class WaterNewContractServiceService extends BaseServiceService<WaterNewContractServiceDto> {
    constructor() {
        super(baseUri);
    }

    public updateFilingOption(transactionId: string, filingOptionId: string): Observable<WaterNewContractServiceDto> {
        return this.httpClient.patch<WaterNewContractServiceDto>(StringUtils.parseUri(`${this.baseUri}/filing-option`, { transactionId }), {
            filingOption: filingOptionId,
        });
    }
}
